export enum CANDIDATE_ROUTES {
  ROUTE_LOGIN_CANDIDATE = "/login",
  ROUTE_HOMEPAGE_CANDIDATE = "/home",
  ROUTE_VIEW_COMPANY_JOBS = "/:companyCode",
  ROUTE_VIEW_COMPANY_SPECIFIC_JOB = "/:companyCode/:jobId",
  ROUTE_BEGIN_EXACT_INTERVIEW = "/interview/:interviewId",
  ROUTE_CHAT_BOT_INTERVIEW = "/interview/:interviewId/session",
  // ROUTE_INTERVIEW_BOT = "/bot",
  ROUTE_SINGPASS_CALLBACK = "/singpass/callback"
}